import { combineReducers } from 'redux';
import auth from './auth';
import notes from './notes';
import notification from './notifications';
import spinner from './spinner';
import courses from './courses';
import courseSections from './courseSections';
import files from './files';
import config from './config';
import exercises from './exercises';
import mobile from './mobile';
import messages from './messages';
import media from './media';
import userState from './userState';
import stats from './stats';
import backendStats from './backendStats';
import tools from './tools';
import course from './course';
import dialogs from './dialogs';
import keyboard from './keyboard';

export default combineReducers({
  auth,
  notes: notes,
  notification,
  spinner,
  courses,
  course,
  courseSections,
  files,
  config,
  exercises,
  mobile,
  messages,
  media,
  userState,
  stats,
  backendStats,
  tools,
  dialogs,
  keyboard,
});